

const firebaseConfig = {
  apiKey: "AIzaSyBrkPZSXZD3VMqVel_DQKvyQONpUnR9jQ0",
  authDomain: "crypto-tracker-5a38d.firebaseapp.com",
  projectId: "crypto-tracker-5a38d",
  storageBucket: "crypto-tracker-5a38d.appspot.com",
  messagingSenderId: "546370133077",
  appId: "1:546370133077:web:ac4568eba4681f938148dc"
};

export default firebaseConfig